import React from "react";
import { useNavigate } from "react-router-dom";

type SectionHeaderProps = {
  title: React.ReactNode;
  showAddTask?: boolean;
  addTaskPath?: string;
  children?: React.ReactNode;
};

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  showAddTask = true,
  addTaskPath = "/tasks/create",
  children,
}) => {
  const navigate = useNavigate();

  return (
    <div
      className="section-header"
      style={{
        marginBottom: "2rem",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          paddingBottom: "0.75rem",
        }}
      >
        <h2
          className="section-title h3"
          style={{
            flex: 1,
            marginBottom: 0,
          }}
        >
          {title}
        </h2>
        {showAddTask && (
          <button
            type="button"
            className="btn btn-primary"
            style={{
              marginLeft: "1rem",
              padding: "0.5rem 1.25rem",
              fontWeight: 500,
              fontSize: "1rem",
              borderRadius: "0.5rem",
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              border: "none",
              whiteSpace: "nowrap",
            }}
            onClick={() => navigate(addTaskPath)}
          >
            + Add Task
          </button>
        )}
      </div>
      <hr
        style={{
          border: 0,
          borderBottom: "2px solid var(--primary)",
          margin: 0,
        }}
      />
      {children && <div style={{ marginTop: "1rem" }}>{children}</div>}
    </div>
  );
};

export default SectionHeader;
